import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { Link } from 'react-router'
import { glimpseRoute } from 'lib/route_utils'
import CrowdFundingPage from 'components/crowdfunding_page'
import CrowdFundingCampaignHeader from 'components/crowdfunding_campaign_header'
import CrowdFundingTabLayout from 'components/crowdfunding_tab_layout'
import styles from './crowdfuding_detail_view.less'
import { Container, HeadingText, CaptionText } from '@paypalcorp/pp-react'

import Strip from 'components/strip'
import FlatProgress from 'components/common/flat_progress'
import CountDown from 'components/common/count_down'
import DonateButton from 'components/pages/crowdfunding/donate_button'
import ShareCampaign from 'components/common/share_campaign_compact'
import ReportLink from 'components/pages/campaign/report_link'
import ModalAnimations from 'components/common/transitions/modal_animations'

import { formatDate } from 'client/griffin'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/crowdfunding_detail_view')

class CrowdfundingDetailView extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string,
    defaultCategoryCover: PropTypes.string,
    campaign: PropTypes.Object,
    preview: PropTypes.bool,
    glimpse: PropTypes.element,
  }

  render() {
    let {
      id,
      is_owner,
      background_image,
      background_pan,
      goal,
      current_value = 0,
      end_date,
      currency,
      pledge = 0,
    } = this.props.campaign

    const localEndDate = formatDate(end_date)
    const customStyle = {
      height: '100%',
      'border-radius': '10px',
    }
    const isPreview = id === '__new_campaign__'
    const showHeader = !isPreview

    return (
      <div>
        <ModalAnimations>{this.props.glimpse}</ModalAnimations>
        <CrowdFundingPage
          showHeader={showHeader}
          showFooter={!isPreview}
          whiteBg={true}
        >
          <Container styleName="campaign_container">
            <div styleName="campaignHeader">
              <CrowdFundingCampaignHeader campaignId={id} />
            </div>
            <div styleName="campaignManage">
              {is_owner && (
                <Link
                  to={glimpseRoute('edit', 'manage')}
                  styleName="btn"
                  data-pa-click="manage"
                  className={`ppvx_btn ppvx_btn--size_sm ppvx_btn--secondary`}
                  data-nemo="manage"
                >
                  {i18n('manage')}
                </Link>
              )}
            </div>
            <div styleName="campaignCover">
              <Strip
                isResponsive={true}
                customStyle={customStyle}
                backgroundImage={
                  background_image || this.props.defaultCategoryCover
                }
                backgroundPan={background_pan}
              />
            </div>
            <div styleName="campaignProgress">
              <FlatProgress
                totalAmount={current_value + pledge}
                goalAmount={goal}
                showPercentage={true}
                showProgress={true}
                currencyCode={currency}
              />
              <CaptionText>{i18n('expires')}</CaptionText>
              <CountDown
                datetime={localEndDate}
                format={['days', 'hours', 'minutes']}
              />
              <div styleName="donate-button">
                <DonateButton campaignId={id} />
              </div>
            </div>
            <div styleName="campaignTabs">
              <CrowdFundingTabLayout campaignId={id} />
            </div>
            <div styleName="campaignSharing">
              {!isPreview && (
                <div styleName="text-center social-share-container">
                  <HeadingText size="sm">
                    {i18n('social_share_heading')}
                  </HeadingText>
                  <CaptionText>{i18n('social_share_subheading')}</CaptionText>
                  <ShareCampaign campaignId={id} />
                </div>
              )}
              <div styleName="campaignReporting">
                {!isPreview && !is_owner && <ReportLink campaignId={id} />}
              </div>
            </div>
          </Container>
        </CrowdFundingPage>
      </div>
    )
  }
}

export default cssModules(CrowdfundingDetailView, styles, {
  allowMultiple: true,
})
